{{#TEMPLATE ctx 'Name'}}
{{#if model.is_active}}<i class="fa fa-check-square-o m-r-5 success"></i>{{else}}<i class="fa fa-square-o m-r-5 error"></i>{{/if}}
<a href="#profile/report-devices/{{model.id}}" data-id="{{model.id}}">{{model.name}}</a>
{{{QUICK_NAVIGATION navigation}}}
{{/TEMPLATE}}

{{#TEMPLATE ctx 'Download'}}
{{#if model.files}}
<a href="#" title="{{TR "Herunterladen"}}" class="js-device-report-download" data-id="{{model.id}}">
	<i class="fa fa-download m-r-5"></i> {{model.files}}
</a>
{{/if}}
{{/TEMPLATE}}

{{#TEMPLATE ctx 'File'}}
{{#if model.is_valid}}
<a href="/api/v1/content/_reports/{{reportID}}/{{model.file}}" target="_blank">{{model.file}}</a>
{{else}}
<i title="{{TR "Datei nicht mehr verfügbar"}}" class="fa fa-exclamation m-r-5 error"></i>{{model.file}}
{{/if}}
{{/TEMPLATE}}
